import axios from "axios";

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function getApiCall(url) {
    return axios.get(process.env.REACT_APP_API_KEY + url, {
        headers: { 'X-User-Timezone': userTimezone}
    })
    .then((data) => {
        return data;
    });
}

function postApiCall(url, body) {
    return axios.post(process.env.REACT_APP_API_KEY + url, body, {
        headers: { 'X-User-Timezone': userTimezone}
    })
    .then((data) => {
        return data;
    });
}

function putApiCall(url, body) {
    return axios.put(process.env.REACT_APP_API_KEY + url, body, {
        headers: { 'X-User-Timezone': userTimezone}
    })
    .then((data) => {
        return data;
    });
}

function deleteApiCall(url, body) {
    return axios.delete(process.env.REACT_APP_API_KEY + url, {
        headers: { 'X-User-Timezone': userTimezone},
        data: body
    })
    .then((data) => {
        return data;
    });
}

export {getApiCall, postApiCall, putApiCall, deleteApiCall };